var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "id-80a", x1: "42.582%", x2: "42.582%", y1: "-99.436%", y2: "392.971%" },
        React.createElement("stop", { offset: "0%", stopColor: "#CBF0F2" }),
        React.createElement("stop", { offset: "100%", stopColor: "#498A90" })
      ),
      React.createElement(
        "linearGradient",
        { id: "id-81b", x1: "41.473%", x2: "41.473%", y1: "201.188%", y2: "50%" },
        React.createElement("stop", { offset: "0%", stopColor: "#113F44" }),
        React.createElement("stop", { offset: "100%", stopColor: "#5D9196" })
      ),
      React.createElement(
        "linearGradient",
        { id: "id-82c", x1: "50%", x2: "50%", y1: "418.301%", y2: "0%" },
        React.createElement("stop", { offset: "0%", stopColor: "#113F44" }),
        React.createElement("stop", { offset: "100%", stopColor: "#80B1B6" })
      ),
      React.createElement(
        "linearGradient",
        { id: "id-83d", x1: "41.473%", x2: "41.473%", y1: "170.01%", y2: "0%" },
        React.createElement("stop", { offset: "0%", stopColor: "#113F44" }),
        React.createElement("stop", { offset: "100%", stopColor: "#80B1B6" })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "url(#id-80a)", d: "M38 37c0 3.785-3.005 6.87-6.76 6.996L31 44H12c-.552 0-1-.448-1-1V11c0-3.866 3.134-7 7-7h20c1.093 0 2.117.292 3 .803-1.733 1.002-2.918 2.846-2.996 4.972L38 10v27z" }),
      React.createElement("path", { fill: "url(#id-81b)", d: "M27 37v1c0 2.613 1.67 4.835 4 5.659V44H10c-3.314 0-6-2.686-6-6v-1h23z" }),
      React.createElement("path", { fill: "url(#id-82c)", d: "M31 29c.552 0 1 .448 1 1s-.448 1-1 1H18c-.552 0-1-.448-1-1s.448-1 1-1h13zm0-4c.552 0 1 .448 1 1s-.448 1-1 1H18c-.552 0-1-.448-1-1s.448-1 1-1h13zm0-4c.552 0 1 .448 1 1s-.448 1-1 1H18c-.552 0-1-.448-1-1s.448-1 1-1h13zm-11.5-9c1.38 0 2.5 1.12 2.5 2.5S20.88 17 19.5 17 17 15.88 17 14.5s1.12-2.5 2.5-2.5z" }),
      React.createElement("path", { fill: "url(#id-83d)", d: "M44 10v2h-6v-2l.004-.225c.078-2.126 1.263-3.97 2.996-4.972 1.793 1.036 3 2.976 3 5.197z" })
    )
  );
});